// Generated by CoffeeScript 1.12.7

/*
A basic 403 access denied page.
 */
angular.module(__filename, ['ui.router', require('goodeggs-ops-sites/angular')]).config([
  '$stateProvider', function($stateProvider) {
    return $stateProvider.state('accessDenied', {
      url: '/access_denied',
      template: require('./template'),
      controller: require('./controller')
    });
  }
]);

module.exports = __filename;
